import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { createTicketGroup, deleteTicketGroup, updateTicketGroup, getAllTicketGroupBySlug, getAllEvents, getEventById } from "../../../api";
import NormalTable from "../../../components/common/Tables/NormalTable";
import * as Yup from "yup";
import { useFormik } from "formik";
import { PulseLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FormattedDate from "../../../components/common/DateFormat/FormattedDate";
import ListCard from "../../../components/common/ListCard/ListCard";
import { useNightMode } from "../../../contexts/NightModeContext";
import Background from "../../Login/Background";
import PageHeader from "../../../components/common/PageHeader/PageHeader";
import { Search } from "lucide-react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import moment from "moment";

const TicketGroup = () => {
  const { isNightMode } = useNightMode();
  const { slug, eventId } = useParams();
  const [ticket, setTicketList] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [showGroupTicketField, setShowGroupTicketField] = useState(false);
  const toggle = () => setModal(!modal);
  const [isLoading, setIsLoading] = useState(true);
  const [editModal, setEditModal] = useState(false);
  const [editingTicket, setEditingTicket] = useState<any>(null);


  useEffect(() => {
    getTicketList();
  }, [slug, eventId]);

  const [fetchError, setFetchError] = useState<string | null>(null);

  const getResolvedSlug = async (targetId?: string): Promise<string> => {
    const idToFind = targetId || eventId || slug;
    const eventData = localStorage.getItem("eventData");
    if (eventData) {
      try {
        const parsed = JSON.parse(eventData);
        if (
          parsed.slugId &&
          isNaN(Number(parsed.slugId)) &&
          (!idToFind || String(parsed.eventId) === String(idToFind) || String(parsed.slugId) === String(idToFind))
        ) {
          return parsed.slugId;
        }
      } catch (e) {}
    }
    if (idToFind && isNaN(Number(idToFind))) {
      return idToFind;
    }
    if (idToFind) {
      try {
        const eventDetails = await getEventById(idToFind);
        if (eventDetails && eventDetails.slugId) {
          localStorage.setItem("eventData", JSON.stringify(eventDetails));
          return eventDetails.slugId;
        }
      } catch (err) {
        console.error("Error fetching event by ID:", err);
      }
    }
    try {
      const res: any = await getAllEvents();
      const list = Array.isArray(res) ? res : res?.data || [];
      const found = list.find(
        (e: any) => String(e.eventId) === String(idToFind) || String(e.id) === String(idToFind)
      );
      if (found) {
        localStorage.setItem("eventData", JSON.stringify(found));
        if (found.slugId) return found.slugId;
      }
    } catch (err) {
      console.error("Error resolving slugId:", err);
    }
    return idToFind || "";
  };

  const getTicketList = async () => {
    try {
      setIsLoading(true);
      const eventSlug = await getResolvedSlug();

      if (eventSlug) {
        const response = await getAllTicketGroupBySlug(eventSlug);
        console.log(response);
        const list = Array.isArray(response) ? response : [];
        setTicketList(list);
        setFetchError(null);
      }
    } catch (error: any) {
      console.error("Error loading ticket groups:", error);
      const isNetErr = error?.message === "Network Error" || !error?.response;
      const msg =
        error?.response?.data?.message ||
        (isNetErr
          ? "Unable to connect to server. Please check network/server status."
          : "Failed to load ticket groups.");
      setFetchError(msg);
      setTicketList([]);
    } finally {
      setIsLoading(false);
    }
  };

  
  const columns = [
    { label: "Ticket Group Name", key: "groupName" },
    {label: "Require Time Slot?",key: "isSlotRequired",
      cellContent: (row: any) => (
        <span>{row?.isSlotRequired ? "True" : "False"}</span>
      ),
    },
    {
      label: "Status",
      key: "status",
      cellContent: (row: any) => {const status = row?.status;
        const statusClass = status === "active" ? "text-success" : status === "inactive" ? "text-danger"  : "";
        return <span className={statusClass}>{status}</span>;
      },
    },
    { label: "Created", key: "createdAt",cellContent: (row: any) => (
      <FormattedDate dateString={row?.createdAt} />
    ) },
    {
      label: "",
      key: "actions",
      cellContent: (row: any) => (
        <div className="d-flex justify-content-center align-items-center gap-4 cursor-pointer">
          <span className="text-primary" onClick={() => handleEdit(row)} >
            <i className="fa-solid fa-pen"></i>
          </span>
          <span className="text-danger" onClick={() => handleDelete(row)} >
            <i className="fa-solid fa-trash-alt"></i>
          </span>
        </div>
      ),
    }
  ];

  const handleSearch = (e: any) => {
    const search = e.target.value;
    setSearch(search);
    if (search.length > 0) {
      const tempTicketList = ticket.filter((ticket: any) =>
        ticket.groupName.toLowerCase().includes(search.toLowerCase())
      );
      setTicketList(tempTicketList);
    } else {
      getTicketList();
    }
  };
  const handleDelete = async (row: any) => {
         if (window.confirm("Are you sure you want to delete this Ticket Group?")) {
           try {
            setIsLoading(true);
             const response = await deleteTicketGroup(row.id);
             toast.success("Ticket Group deleted successfully!");
              getTicketList();
           } catch (error:any) {
             const errorMsg = error.response?.data?.message ||
                     "Failed to delete Ticket Group";
                   toast.error(errorMsg);
           }
            finally {
              setIsLoading(false);
            }
         }
       };
  const handleEdit = (ticket: any) => {
  setEditingTicket(ticket);
  setEditModal(true);
};
const editFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      groupName: editingTicket?.groupName || "",
      isSlotRequired: editingTicket?.isSlotRequired?.toString() || "",
      status: editingTicket?.status || "active",
    },
    validationSchema: Yup.object({
      groupName: Yup.string().required("Group Ticket Name is required"),
      isSlotRequired: Yup.string().required("Is Slot Required"),
      status: Yup.string().required("Status is required"),
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const payload = {
          groupName: values.groupName,
          isSlotRequired: values.isSlotRequired,
          status: values.status,
        };
        await updateTicketGroup(editingTicket.id, payload); 
        toast.success("Ticket Group updated successfully!");
        setEditModal(false);
        getTicketList();
      } catch (error) {
        toast.error("Failed to update Ticket Group");
      }
      finally {
        setIsLoading(false);
      }
    },
  });
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      groupName: "",
      isSlotRequired: "",
      eventSlug: slug || "",
      status: "active",
    },
    validationSchema: Yup.object({
      groupName: Yup.string().required("Group Ticket Name is required"),
      isSlotRequired: Yup.string().required("Is Slot Required"),
      status: Yup.string().required("Status Required"),
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const eventData = localStorage.getItem("eventData");
        if (eventData) {
          const eventSlugId = JSON.parse(eventData).slugId;
          const payload = {
            groupName: values.groupName,
            isSlotRequired: values.isSlotRequired,
            slugId: eventSlugId,
            status: 'active',
          };
          const response = await createTicketGroup(payload);
          toast.success("Ticket Group Created successfully!");
          toggle();
          getTicketList();
        }
      } catch (error) {
        console.error("Error creating ticket group!", error);
        toast.error("Error creating ticket group.");}
      finally {
        setIsLoading(false);
      }
    },
  });
  return (
    <div className={`contact-list-container ${isNightMode ? 'text-white' : 'text-dark'}`}>
      <Background />
      <ToastContainer autoClose={2000} />
      <PageHeader
        title="Group Ticket List"
        subtitle="Manage and categorize event ticket groups, bundle rates, and specialized slot allocations."
        isLoading={isLoading}
        actions={
          <Button color="danger" onClick={toggle} className="v3-btn-primary h_40 d-flex align-items-center">
            <i className="fa-solid fa-plus me-2"></i> New Group Ticket
          </Button>
        }
      />

      <div className="contact-filter-card mb-4 mt-4">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
          <div className="position-relative flex-grow-1 w-100">
            <Search className="position-absolute start-0 top-50 translate-middle-y ms-3 contact-sub-text" size={18} />
            <input
              type="text"
              className="contact-search-input"
              placeholder="Search by group name..."
              value={search}
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>

      {fetchError && !isLoading && ticket.length === 0 && (
        <div
          className="d-flex flex-column align-items-center justify-content-center text-center py-5"
          style={{ gap: 12 }}
        >
          <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: 36, color: "#EE3F7C" }}></i>
          <p className="fw-semibold mb-1" style={{ fontSize: 15, color: isNightMode ? "#f1f5f9" : "#0f172a" }}>
            Unable to load ticket groups
          </p>
          <p className="font-mono mb-3" style={{ fontSize: 12, color: isNightMode ? "rgba(255,255,255,0.5)" : "#64748b" }}>
            {fetchError}
          </p>
          <Button
            color="danger"
            outline
            size="sm"
            onClick={getTicketList}
          >
            <i className="fa-solid fa-rotate-right me-2"></i> Retry
          </Button>
        </div>
      )}

      <div>
        <Modal isOpen={modal} toggle={toggle} modalClassName="quick-v2-glass-modal" size="lg">
          <ModalHeader toggle={toggle} className="border-bottom border-secondary">
            <span style={{ fontSize: '1.1rem', fontWeight: 600, letterSpacing: '0.5px' }}>
              🎫 Add New Group Ticket
            </span>
          </ModalHeader>
          <Form onSubmit={validation.handleSubmit}>
            <ModalBody className="p-4">
              <FormGroup>
                <Label className="text-uppercase text-secondary font-monospace" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                  GROUP TICKET NAME *
                </Label>
                <Input
                  name="groupName"
                  type="text"
                  placeholder="e.g. VIP Club Access"
                  className="bg-dark text-white border-secondary"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.groupName}
                  invalid={
                    validation.touched.groupName &&
                    !!validation.errors.groupName
                  }
                />
                {validation.touched.groupName &&
                validation.errors.groupName ? (
                  <FormFeedback type="invalid" className="d-block text-danger mt-1">
                    {validation.errors.groupName}
                  </FormFeedback>
                ) : null}
              </FormGroup>

              <FormGroup>
                <Label className="text-uppercase text-secondary font-monospace" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                  IS SLOT REQUIRED *
                </Label>
                <Input
                  name="isSlotRequired"
                  type="select"
                  className="bg-dark text-white border-secondary"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.isSlotRequired}
                  invalid={
                    validation.touched.isSlotRequired &&
                    !!validation.errors.isSlotRequired
                  }
                >
                  <option value="">Select</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </Input>
                {validation.touched.isSlotRequired &&
                validation.errors.isSlotRequired ? (
                  <FormFeedback type="invalid" className="d-block text-danger mt-1">
                    {validation.errors.isSlotRequired}
                  </FormFeedback>
                ) : null}
              </FormGroup>
            </ModalBody>
            <ModalFooter className="border-0 pt-0">
              <Button type="button" outline color="light" onClick={toggle} className="me-2 rounded-pill px-4">
                Cancel
              </Button>
              <Button color="primary" disabled={isLoading} type="submit" className="btn-primary rounded-pill px-4">
                <i className="fa-solid fa-floppy-disk me-2"></i>
                {isLoading ? "Creating..." : "Save Group Ticket"}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
        <Modal isOpen={editModal} toggle={() => setEditModal(!editModal)} modalClassName="quick-v2-glass-modal" size="lg">
          <ModalHeader toggle={() => setEditModal(!editModal)} className="border-bottom border-secondary">
            <span style={{ fontSize: '1.1rem', fontWeight: 600, letterSpacing: '0.5px' }}>
              🎫 Edit Ticket Group
            </span>
          </ModalHeader>
          <Form onSubmit={editFormik.handleSubmit}>
            <ModalBody className="p-4">
              <FormGroup>
                <Label className="text-uppercase text-secondary font-monospace" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                  GROUP TICKET NAME *
                </Label>
                <Input
                  name="groupName"
                  type="text"
                  className="bg-dark text-white border-secondary"
                  onChange={editFormik.handleChange}
                  onBlur={editFormik.handleBlur}
                  value={editFormik.values.groupName}
                  invalid={editFormik.touched.groupName && !!editFormik.errors.groupName}
                />
                <FormFeedback className="d-block text-danger mt-1">{editFormik.errors.groupName as any}</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label className="text-uppercase text-secondary font-monospace" style={{ fontSize: '11px', letterSpacing: '1px' }}>
                  STATUS
                </Label>
                <Input
                  name="status"
                  type="select"
                  className="bg-dark text-white border-secondary"
                  onChange={editFormik.handleChange}
                  onBlur={editFormik.handleBlur}
                  value={editFormik.values.status}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Input>
              </FormGroup>
            </ModalBody>
            <ModalFooter className="border-0 pt-0">
              <Button type="button" outline color="light" onClick={() => setEditModal(false)} className="me-2 rounded-pill px-4">
                Cancel
              </Button>
              <Button color="primary" disabled={isLoading} type="submit" className="btn-primary rounded-pill px-4">
                <i className="fa-solid fa-floppy-disk me-2"></i>
                {isLoading ? "Saving..." : "Save Changes"}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>

                    {isLoading ? (
                      <div className="d-flex justify-content-center py-4">
                        <PulseLoader color="#ffffff" size={9} speedMultiplier={1} />
                      </div>
                    ) : (
                      <div className="mt-4">
                        {ticket.length > 0 ? (
                          ticket.map((tickets: any) => (
                            <ListCard
                              key={tickets.ticketTypeId}
                              cardData={{
                                icon: "fa-solid fa-users",
                                name: tickets.groupName,
                                startDate: tickets.createdAt,
                                status: tickets.status,
                                isActive: tickets.status === "active",
                                optionHead: "Require Time Slot?",
                                option: tickets.isSlotRequired ? "Yes" : "No",
                              }}
                              onEdit={() => handleEdit(tickets)}
                              onDelete={() => handleDelete(tickets)}
                            />
                          ))
                        ) : (
                          <p className="text-muted">No group tickets available</p>
                        )}
                      </div>
                    )}
                  </div>
  );
};

export default TicketGroup;